<template>
  <v-navigation-drawer v-model="valueLocal" app temporary left width="648">
    <div class="d-flex justify-space-between align-center pa-6">
      <h3 class="font-24 font-weight-bold primary--text">Why Paymentshield?</h3>

      <v-btn icon aria-label="Close" @click="closeWhyChooseUsDrawer">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </div>
    <v-divider></v-divider>

    <div class="px-6 py-10 primary--text">
      <component :is="getWhyChooseUsComponent"></component>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "DrawerWhyChooseUs",
  components: {
    Home: () => import("@/views/Home/B2B/WhyChooseUsContent"),
    Landlords: () => import("@/views/Landlords/B2B/WhyChooseUsContent"),
    Tenants_Contents: () =>
      import("@/views/Tenants/B2B/TenantsContents/WhyChooseUsContent"),
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["productId", "getWhyChooseUsComponent"]),
    valueLocal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeWhyChooseUsDrawer() {
      this.$emit("closeWhyChooseUsDrawer");
    },
  },
};
</script>

<style lang="scss" scoped></style>
